import type {GuidedItemsV2} from './models/models';
import type {GuidedUiElementVisibility, GuidedV2Schema} from './models/ui';
import type {labelProviderInterface} from '../LabelProviderInterface';

export class GuidedDataFlux{

  schema: GuidedV2Schema;
  /**
   * List of results to display
   */
  results: GuidedItemsV2 = [];


  searchTerm: string = '';

  /**
   * The name of the section that is currently opened
   * Is set by Listener to guided:chipClicked event
   * is read to determine if a section should be opened or closed
   * this way we can have tab-like behavior
   */
  openedSection: string = '';

  /**
   * The index of the highlighted item in the results list
   * -1 when no preselection 0 when first link is selected 9 when 10th link is selected
   */
  highlightedIndex: number = -1;
  /**
   * Index of highlighted link within horizontal sections
   */
  sideHighlightIndex: number = -1;
  /**
   * i18n utility. May be used inside middleware to pass it to templated components
   */
  labelProvider: labelProviderInterface = (key, fallback) => fallback;


  /**
   * The direction of the text in the UI, as read from html, body, or guided element.
   */
  rightToLeft: boolean = false;

  /**
   * True if Guided is opened
   */
  opened: boolean = false;

  mouseHoversGuidedPanel: boolean = false;

  showBackdrop: boolean = false;

  requestInProgress:{
    finishedAt?: DOMHighResTimeStamp,
    startedAt?: DOMHighResTimeStamp,
    isRunning: boolean,
  };

  constructor(){
      this.schema = {
        minLength: 1,
        sections: []
      };
  }

  /**
   * Check if Guided UI element is visible, depending on its visibility setting.
   * Used for examining the `showWhen` property
   * @param visibility
   * @param section name of the section to verify agains, used only for 'has-results' and 'has-no-results'
   */
  public checkVisibility(visibility: GuidedUiElementVisibility): boolean{
      switch(visibility){
      case 'always': return true;
      case 'no-search-term': return this.searchTerm === '' || this.searchTerm?.length < this.schema.minLength;
      case 'has-search-term': return this.searchTerm !== '' && this.searchTerm?.length >= this.schema.minLength;

      case 'search-term-too-short': return this.searchTerm !== '' && this.searchTerm.length < this.schema.minLength;

      case 'has-search-term-with-results-loaded':
        return this.searchTerm !== ''
          && this.searchTerm.length >= this.schema.minLength
          && this.requestInProgress.isRunning === false;

      case 'still-loading-after-1s':
        return this.requestInProgress.isRunning
          && this.requestInProgress.startedAt
          && performance.now() - this.requestInProgress.startedAt > 1000;
      case 'still-loading-after-5s':
        return this.requestInProgress.isRunning
          && this.requestInProgress.startedAt
          && performance.now() - this.requestInProgress.startedAt > 5000;
      default:
        const exhaustiveCheck: never = visibility; //eslint-disable-line @typescript-eslint/no-unused-vars
        throw new Error(`Unhandled visibility case: ${exhaustiveCheck}`);
      }
  }

}
